import React from 'react';
import { Text } from 'components/typography/Text';
import styles from './styles.module.scss';

export const ActionButton = ({ children, intl }) => (
  <div className={styles.actionButton}>
    {children}

    <Text
      intl={intl}
      size={10}
      underline
    />
  </div>
);

